import { Flex, List } from 'antd';
import Title from 'antd/es/typography/Title';
import Typography from 'antd/es/typography/Typography';
import cn from 'classnames';

import BrandEntityCollapsableItem from '@/components/common/BrandEntityCollapsableItem';
import PromptsBrandEntityCollapsableItem from '@/components/common/PromptsBrandEntityCollapsableItem';
import { TTitle, titles } from '@/components/common/TabsControls';
import VideoPlatformLink from '@/components/common/VideoPlatformLink';
import VideoPlayer from '@/components/common/VideoPlayer';
import { CDN_URL } from '@/const';
import useTabVideoPlayer from '@/hooks/useTabVideoPlayer';
import placeholderImg from '@/lib/assets/placeholder.jpg';
import prepareCdnVideoUrl from '@/lib/helpers/prepareCdnVideoUrl';
import prepareImageSrc from '@/lib/helpers/prepareImageSrc';

import styles from '../../styles.module.css';

import { TActiveMenuTab } from '../..';
import { mockData2 } from '../data';

type TProps = {
	data?: any;
	item: any;
	activeTab: TActiveMenuTab;
};

type TVideoData = typeof mockData2.content;

export default function BrandsEntities({ activeTab, item }: TProps) {
	const { wrapperRef, playerRef, seekToTime } = useTabVideoPlayer(
		activeTab,
		'brands-entities',
	);

	const entities: TVideoData['textAnalytics']['entities'] =
		item?.content?.textAnalytics?.entities;
	const videoCdnUrl = item?.content?.metaData?.cdnPath;
	const videoDuration = item?.content?.metaData?.duration
		? Number(item?.content?.metaData?.duration)
		: 0;

	if (activeTab !== 'brands-entities') {
		return null;
	}

	const allEntities = Object.keys(entities ?? {})
		?.reduce((acc: any, key: string) => {
			const entity = entities?.[key as keyof typeof entities] || {};

			const currentEntityEntries = Object.entries(entity);

			currentEntityEntries.forEach(([intKey, intValue]) => {
				if (intValue) {
					acc.push({
						[intKey]: intValue,
					});
				}
			});

			return acc;
		}, [])
		?.sort((a: any, b: any) => {
			const aCount = Object.keys(a)?.[0] || '';
			const bCount = Object.keys(b)?.[0] || '';
			return aCount.localeCompare(bCount); // Sort by count in descending order
		});

	return (
		<Flex
			gap={16}
			align="flex-start"
			className={styles.flexWrapper}
			vertical
			style={{ width: '100%' }}
		>
			<Flex
				vertical
				align="center"
				justify="center"
				className={styles.videoWrapper}
				gap={16}
				style={{ width: '100%' }}
			>
				<div className={styles.imageWrapper} ref={wrapperRef}>
					{videoCdnUrl && (
						<VideoPlayer
							playerRef={playerRef}
							preview={
								!item?.metaData?.thumbnail.includes('.cdninstagram.')
									? item?.metaData?.thumbnail
									: placeholderImg
							}
							url={prepareCdnVideoUrl(videoCdnUrl)}
						/>
					)}
					{!videoCdnUrl && (
						<>
							{item?.metaData?.thumbnail &&
							!item?.metaData?.thumbnail.includes('.cdninstagram.') ? (
								<img
									src={
										item?.metaData?.thumbnail?.startsWith('http')
											? item?.metaData?.thumbnail
											: CDN_URL + prepareImageSrc(item?.metaData?.thumbnail)
									}
									alt=""
								/>
							) : (
								<img
									src={placeholderImg}
									width={130}
									height={124}
									alt="'Image not found' placeholder"
								/>
							)}
						</>
					)}
				</div>
				<VideoPlatformLink item={item} />
			</Flex>
			<Flex
				vertical
				align="flex-start"
				gap={8}
				className={styles.metaContentWrapper}
				wrap
				style={{ width: '100%' }}
			>
				{/* <Title level={4} className={cn(styles.tabTitle, styles.mb0)}>
					<span className={styles.underline}>
						{titles[activeTab as TTitle]}
					</span>
				</Title> */}
				<Flex vertical gap={4} align="flex-start" style={{ width: '100%' }}>
					<Flex
						vertical
						key={'entity-items'}
						style={{
							width: '100%',
							textAlign: 'left',
							// paddingLeft: "0.5rem"
						}}
					>
						{/* <Typography.Title level={4} className={styles.brandEntityTitle}>
                  {entity?.Name}
                </Typography.Title> */}
						{allEntities?.length > 0 ? (
							<List
								itemLayout="horizontal"
								className={styles.keyInsights}
								dataSource={allEntities ?? []}
								renderItem={(item: any, index) => (
									<PromptsBrandEntityCollapsableItem
										item={item}
										key={'BrandEntityCollapsableItem' + index}
										videoSeekToTime={seekToTime}
										videoDuration={videoDuration}
									/>
								)}
							/>
						) : (
							<span style={{ color: 'gray' }}>n/a</span>
						)}
					</Flex>
				</Flex>
			</Flex>
		</Flex>
	);
}
